"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.OrderStatusPage=void 0;var d;(function(e){e.Cancelled="cancelled",e.Delivered="delivered",e.Map="map",e.NonMap="non_map",e.Scheduled="scheduled"})(d||(exports.OrderStatusPage=d={}));
//# sourceMappingURL=OrderStatusPage.js.map
